<template>
  <BaseDropdown>
    <template #trigger="{ isActive }">
      <HeaderIconButton
        :is-active="isActive"
      >
        <template #icon>
          <DownloadCircleSvg />
        </template>
        <template #label>
          Export
        </template>
      </HeaderIconButton>
    </template>

    <template #content>
      <div :class="$style.dropdown">
        <BaseDropdownHeading>
          Export data
        </BaseDropdownHeading>
        <BaseDropdownActionsList>
          <BaseDropdownAction
            @click="exportExcel"
          >
            <span :class="$style.exportButton">
              Excel file
              <FileExcelSvg />
            </span>
          </BaseDropdownAction>
        </BaseDropdownActionsList>
      </div>
    </template>
  </BaseDropdown>
</template>

<script>
import BaseDropdown, {
  DropdownAction as BaseDropdownAction, DropdownHeading as BaseDropdownHeading,
  DropdownActionsList as BaseDropdownActionsList,
} from '@/components/base/Dropdown';
import HeaderIconButton from '@/components/HeaderIconButton';
import DownloadCircleSvg from '@/assets/images/icons/download-circle.svg?inline';
import FileExcelSvg from '@/assets/images/icons/file-excel.svg?inline';

export default {
  components: {
    BaseDropdown,
    BaseDropdownHeading,
    BaseDropdownActionsList,
    BaseDropdownAction,
    HeaderIconButton,
    DownloadCircleSvg,
    FileExcelSvg,
  },
  emits: {
    exportExcel: null,
  },
  methods: {
    exportExcel() {
      this.$emit('exportExcel');
    },
  },
};
</script>

<style lang="scss" module>
.dropdown {
  min-width: 200px;
}

.exportButton {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
